import api from './client.js'

export const wreckfestAPI = {
  getConfig: () => api.get('/wreckfest/config'),
  updateConfig: (updates) => api.put('/wreckfest/config', { updates }),
  restart: () => api.post('/wreckfest/restart'),
  getStatus: () => api.get('/wreckfest/status'),
  getLog: (lines = 200) => api.get(`/wreckfest/log?lines=${lines}`),
  sendCommand: (command) => api.post('/wreckfest/command', { command }),
  listPresets: () => api.get('/wreckfest/presets'),
  savePreset: (name) => api.post('/wreckfest/presets', { name }),
  loadPreset: (slug) => api.post(`/wreckfest/presets/${slug}/load`),
  deletePreset: (slug) => api.delete(`/wreckfest/presets/${slug}`),
  downloadPreset: (slug) => api.get(`/wreckfest/presets/${slug}/download`, { responseType: 'blob' }),
  uploadPreset: (name, content) => api.post('/wreckfest/presets/upload', { name, content }),
  getEventLoop: () => api.get('/wreckfest/eventloop'),
  updateEventLoop: (events) => api.put('/wreckfest/eventloop', { events }),
}
